import React from 'react'
import { useSelector } from '~/store/hooks'

import { Link } from 'gatsby'
import trads from '~/intl/trads.json'
import LinkIcon from '~/components/core/linkIcon'
import Image from '~/components/core/Image'
import transformLink from '~/utils/transformLink'
import { ImageNew } from '~/components/core/ImageNew'

const NewsCard = ({
  news,
  isXl = false,
  isFull = false,
  projectSheet = false,
}) => {
  const lang = useSelector((state) => state.lang)
  const url = transformLink(news, false, true).url
  const details =
    news.mainImage &&
    (news?.mainImage?.fields?.file?.fields?.file?.detail ??
      news?.mainImage?.file?.file?.details)

  const mainImageHeight = details ? details.image.height : ''

  const width = isFull ? 350 : mainImageHeight > 525 ? 570 : false
  const height = isFull ? 224 : false

  const dateOptions = { year: 'numeric', month: 'short', day: 'numeric' }
  const publicationDate = new Date(news.publicationDate).toLocaleDateString(
    lang,
    dateOptions,
  )

  return (
    <Link
      to={url}
      className={`news-card card ${isFull ? 'card--short-picture' : ''}`}
    >
      <>
        {news.mainImage && (
          <div
            className={`relative card__bg news-card__bg ${isFull ? 'card__bg--short-picture' : ''}`}
          >
            <Image
              image={news.mainImage}
              isBg={true}
              width={width}
              height={height}
              maxWidth={isFull ? false : true}
              sizes={{ 415: [315, 201], 767: [707, 452], 1023: [466, 298] }}
            />
          </div>
        )}

        {!news.mainImage && (
          <div
            className={`card__bg news-card__bg card__bg--empty ${isFull && 'card__bg--short-picture'}`}
          ></div>
        )}
      </>
      <div
        className={`card__content news-card__content ${isXl ? 'card__content--xl' : ''} ${isFull ? 'card__content--full' : ''}`}
      >
        <span className="text-label text-label--bg text-white bg-blue card__tag">
          {trads[lang].news}
        </span>
        <div>
          <span className="text-label text-blue mb-2 block">
            {publicationDate}
          </span>
          <h3
            className={`${isFull ? 'title-3-bold title-3-bold--small mb-8' : 'title-3-bold mb-5'}`}
          >
            {news.title}
          </h3>
        </div>
        <LinkIcon text={trads[lang].learnMore} />
      </div>
    </Link>
  )
}

export default NewsCard
